import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@esgian/esgianui';
import { useTheme } from '@hooks';

function FuelSelect({
  label,
  placeholder = 'Select fuel type',
  selectedFuel = {},
  handleChange,
  id = 'fuel-select',
  variant = 'outlined',
  size = 'medium',
  supportedFuels = []
}) {
  const { customScrollbar } = useTheme();

  return (
    <Autocomplete
      id={id}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      fullWidth
      onChange={(_, fuel) => handleChange(fuel)}
      disableClearable
      ListboxProps={{ sx: { ...customScrollbar } }}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {option.name}
        </li>
      )}
      getOptionLabel={(option) => option.name}
      value={selectedFuel}
      options={supportedFuels}
      size={size}
      renderInput={(params) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: '200px' }}
          placeholder={placeholder}
          fullWidth
          {...params}
          label={label}
          variant={variant}
        />
      )}
    />
  );
}

FuelSelect.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  selectedFuel: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  supportedFuels: PropTypes.array
};

export default FuelSelect;
